export default "__VITE_ASSET__Dp39GFTE__"